export default "__VITE_ASSET__CAd3BHmf__"